import { render } from "./tamap.vue?vue&type=template&id=4d098200"
import script from "./tamap.vue?vue&type=script&lang=js"
export * from "./tamap.vue?vue&type=script&lang=js"

import "./tamap.vue?vue&type=style&index=0&id=4d098200&lang=scss"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__